import {debounce} from "debounce";

export default function (opt) {
    let timeout = opt.timeout ? opt.timeout : 500;
    let waitTime = opt.waitTime ? opt.waitTime : 0;
    let scrollDepth = opt.scrollDepth ? opt.scrollDepth : 0;
    let func = opt.func;
    let loadStarted = false;

    window.addEventListener('scroll', debouncer);

    function debouncer() {
        debounce(function (scrollEvent) {
            if (loadStarted || window.pageYOffset < scrollDepth)
                return false;
            loadStarted = true;
            setTimeout(function () {
                func()
            }, timeout);
        }, waitTime)();
    }
}